import type { CdkDragDrop } from '@angular/cdk/drag-drop'
import { transferArrayItem, copyArrayItem } from './frontend-data-bridge.js'

export { transferArrayItem, copyArrayItem } from '@angular/cdk/drag-drop'
export * from '@lg/shared/bridges/data'

export function transferFromDropEvent(event: CdkDragDrop<any>) {
	if (
		event.previousContainer == event.container &&
		event.previousIndex == event.currentIndex
	)
		return
	transferArrayItem(
		event.previousContainer.data,
		event.container.data,
		event.previousIndex,
		event.currentIndex,
	)
}

export function copyFromDropEvent(event: CdkDragDrop<any>) {
	if (
		event.previousContainer == event.container &&
		event.previousIndex == event.currentIndex
	)
		return
	copyArrayItem(
		event.previousContainer.data,
		event.container.data,
		event.previousIndex,
		event.currentIndex,
	)
}
